<template>
  <div class="main-wrapper">
    <VehicleForm
      v-for="(vehicle, index) in formFields"
      :key="vehicle.id || index"
      v-model="formFields[index]"
      :index="index"
      :vehicle-types="vehicleTypes"
      :error-resolver="errorResolver"
      :hide-deposit="hideDeposit"
      @delete="handleDeleteClick"
      :form-length="visibleVehiclesLength"
    />
    <div class="actions">
      <button @click="handleAddClick" type="button" class="btn btn-secondary">Add vehicle</button>
    </div>
  </div>
</template>

<script>
import VehicleForm from './VehicleForm.vue';
import { apiRequest } from '@/api/apiRequest';

export default {
  data() {
    return {
      vehicleTypes: [],
    };
  },
  components: {
    VehicleForm
  },
  computed: {
    visibleVehiclesLength() {
      return this.formFields.filter(v => !v._delete).length;
    }
  },
  props: {
    formFields: {
      type: Array,
      default: () => ({}),
    },
    errorResolver: {
      type: Function,
      default: () => [],
    },
    hideDeposit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleAddClick() {
      const newFormFields = this.formFields.concat([{ isInoperable: '0' }]);
      this.$emit('input', newFormFields);
    },
    handleDeleteClick(index) {
      const vehicleToRemove = Object.assign({}, this.formFields[index]);
      // If vehicle exists on the back-end, we just mark it for deletion
      // if it does not (when user just clicked 'Add vehicle' button), then we remove it completely from the UI.
      if (vehicleToRemove.id) {
        vehicleToRemove._delete = true;
        const newFormFields = this.formFields.map((v, i) => (index === i ? vehicleToRemove : v));
        this.$emit('input', newFormFields);
      } else {
        const newFormFields = this.formFields.filter((_, i) => i != index);
        this.$emit('input', newFormFields);
      }
    },
  },
  async mounted() {
    const response = await apiRequest({
      path: '/vehicle-types',
    });
    if (response.status === 200) {
      this.vehicleTypes = response.data.data;
    }
  },
};
</script>

<style lang="scss" scoped>
.actions {
  padding: 16px 0 0 0;
}
</style>
